import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (value?.length !== 4) {
      return value; // Return as is if the value is not in "hhmm" format
    }

    const hours = value.substring(0, 2);
    const minutes = value.substring(2, 4);

    return `${hours} ${minutes}`;
  }
}
